import baseApi from "./baseApi"

export default  {
    /**
     * Get all User Locations     
     */
    async getLocations() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get('/traps/locations');
        return result.data;
    },
    async getTraps() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/traps");
        return result.data;
    },
    async getTrapByID(id) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/traps/${id}`);
        return result.data;
    },
    async getTrapsByPlant(plantID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/traps?plantID=" + plantID);
        return result.data;
    },
    async getTrapsForLocationByTrapID(trapID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/traps/locations?trapID=" + trapID);
        return result.data;
    },
    async addTrap(item) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post("/traps", item);
        return result.data;
    },
    async updateTrap(item) {
        let request = await baseApi.createHttpRequest();
        let result = await request.put("/traps", item);
        return result.data;
    },
    async getTrapZones() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/traps/zones");
        return result.data;
    },
    async getPheromones() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/traps/pheromones");
        return result.data;
    }
}